<template>
  <div>
    <!-- About Section -->
    <div class="w3-container w3-padding-32" id="about">
      <h3 class="w3-border-bottom w3-border-light-grey w3-padding-16">О нас</h3>
      <p>
        Мы пропагандируем здоровый образа жизни, объединяем любителей бега,
        развиваем и популяризируем бег и легкую атлетику на территории
        "Сколково", "Мещерский парк" и за их пределами, оказываем взаимопомощь и поддержку между
        участниками.
      </p>
    </div>
    <div class="w3-row-padding w3-grayscale">
      <div class="w3-col l3 m6 w3-margin-bottom">
        <div class="card">
          <img
            src="https://scontent-arn2-1.cdninstagram.com/v/t51.2885-15/sh0.08/e35/s640x640/64988967_315695916049291_1713915638952625147_n.jpg?_nc_ht=scontent-arn2-1.cdninstagram.com&_nc_cat=107&_nc_ohc=3SyU2pDd1cAAX9MI6hm&oh=7029cf996dc0d7fe888908ac1375943b&oe=5E9AE4ED"
            alt="Евгений Летенков"
            style="width:100%"
          />
          <div class="container">
            <h4>
              <b>Евгений Летенков</b>
            </h4>
            <p class="title">Создатель клуба</p>
            <!-- <p>Технопредприниматель и спортсмен.</p> -->
            <!-- <div style="margin: 24px 0;">
              <a href="https://www.instagram.com/letenkov.run"
                ><font-awesome-icon :icon="instagram" />
              </a>
              <a href="https://facebook.com/letenkov.run"
                ><font-awesome-icon :icon="facebook" />
              </a>
              <a href="https://twitter.com/letenkovrun"
                ><font-awesome-icon :icon="twitter" />
              </a>
              <a href="https://"><font-awesome-icon :icon="twitter" /> </a>
            </div>-->
          </div>
        </div>
      </div>
      <!-- <div class="w3-col l3 m6 w3-margin-bottom">
        <div class="card">
          <img
            src="https://via.placeholder.com/293x293"
            alt="Владимир Соватенков"
            style="width:100%"
          />
          <div class="container">
            <h4>
              <b>Владимир Соватенков</b>
            </h4>
            <p class="title">Тренер клуба SkRun</p>
            <p>...</p>
          </div>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
// import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import {
  faTwitter,
  faFacebook,
  faInstagram
} from "@fortawesome/free-brands-svg-icons";
export default {
  name: "About",

  computed: {
    twitter() {
      return faTwitter;
    },
    facebook() {
      return faFacebook;
    },
    instagram() {
      return faInstagram;
    }
  }
};
</script>

<style scoped>
.title {
  color: grey;
  font-size: 18px;
}
a {
  text-decoration: none;
  font-size: 22px;
  color: black;
}
</style>
